import Button from '../Button/Button';
import React from 'react';
import { Body1Reg, Title2 } from '../../config/designSystem/typography';
import { COLORS } from '../../config/designSystem/Colors';
import { MaterialIcons } from '@expo/vector-icons';
import { PublicPagesHeader } from '../Header/PublicPages';
import { SPACING } from '../../config/designSystem/Spacing';
import { SafeAreaView, View } from 'react-native';
import { useStores } from '../../hooks/useStores';

type MaintenanceProps = {
  onRetry: () => void;
};

// Shown by UpdateApp in place of the whole app while the admin's maintenance switch for this
// platform is on. Fallback texts cover a label that is missing or not translated yet.
export const Maintenance = ({ onRetry }: MaintenanceProps) => {
  const rootStore = useStores();
  const labels = rootStore?.language.translate.MOBILE?.ROOT?.MAINTENANCE;

  return (
    <View style={{ flex: 1, backgroundColor: 'white' }}>
      <SafeAreaView style={{ paddingHorizontal: 40, backgroundColor: 'white' }}>
        <PublicPagesHeader onPress={() => {}} withContactToSupport={false} />
      </SafeAreaView>
      <View style={{ padding: SPACING['sp-16'], flex: 1 }}>
        <View style={{ flex: 1, alignItems: 'center', rowGap: SPACING['sp-32'] }}>
          <MaterialIcons name='engineering' size={104} color={COLORS.brand[500]} />
          <Title2>{labels?.TITLE ?? 'Under maintenance'}</Title2>
          <Body1Reg align={true}>
            {labels?.EXPLANATION ?? 'We are improving evoluno for you. The app will be back very soon. Thank you for your patience!'}
          </Body1Reg>
        </View>
        <SafeAreaView>
          <Button onPress={onRetry} label={labels?.RETRY ?? 'Try again'} />
        </SafeAreaView>
      </View>
    </View>
  );
};
